import { filterARecords, filterAaaaRecords } from './dnsRecordType';

function ipRowMatchesNeedle(ip, geos, needleLower) {
  const geo = (geos || []).find((g) => g.ipAddress === ip.ipAddress);
  const hay = [
    ip.ipAddress,
    ip.domain,
    geo?.city,
    geo?.country,
    geo?.asn,
    geo?.asnOrg,
    geo?.asn_org,
    geo?.postalCode,
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
  return hay.includes(needleLower);
}

/**
 * Map a home-search tool `sourceKind` to the case Investigation Data tab and
 * the `data-section-id` to expand/scroll (SecurityTrails accordion or tab panel).
 */
export function destinationForToolSourceKind(sourceKind, { details, needle } = {}) {
  const kind = String(sourceKind || '').toUpperCase();
  const needleLower = typeof needle === 'string' ? needle.trim().toLowerCase() : '';
  const ipLooksV6 = needleLower.includes(':');

  switch (kind) {
    case 'WHOIS':
      return { tab: 'securitytrails', sectionId: 'st-whois-current' };
    case 'HISTORICAL_WHOIS':
      return { tab: 'securitytrails', sectionId: 'st-whois-historical' };
    case 'NAMESERVER':
      return { tab: 'securitytrails', sectionId: 'st-ns-records' };
    case 'IP_ADDRESS':
    case 'IP_GEOLOCATION': {
      let sectionId = ipLooksV6 ? 'st-aaaa-records' : 'st-a-records';
      const ips = details?.ipAddresses;
      if (Array.isArray(ips) && needleLower) {
        const geos = details?.ipGeolocations || [];
        const match = (ip) => ipRowMatchesNeedle(ip, geos, needleLower);
        const aHit = filterARecords(ips).some(match);
        const aaaaHit = filterAaaaRecords(ips).some(match);
        if (aaaaHit && !aHit) sectionId = 'st-aaaa-records';
        else if (aHit) sectionId = 'st-a-records';
      }
      return { tab: 'securitytrails', sectionId };
    }
    case 'SOA':
      return { tab: 'securitytrails', sectionId: 'st-soa-records' };
    case 'TXT':
      return { tab: 'securitytrails', sectionId: 'st-txt-records' };
    case 'MX':
      return { tab: 'securitytrails', sectionId: 'st-mx' };
    case 'SUBDOMAIN':
      return { tab: 'securitytrails', sectionId: 'st-subdomains' };
    case 'DOMAINS_ON_IP':
      return { tab: 'securitytrails', sectionId: 'st-domains-ip' };
    case 'DOMAINS_ON_NS':
      return { tab: 'securitytrails', sectionId: 'st-domains-ns' };
    case 'HISTORICAL_DNS':
      return { tab: 'securitytrails-historical', sectionId: 'tab-securitytrails-historical' };
    case 'URLSCAN':
      return { tab: 'urlscan', sectionId: 'tab-urlscan' };
    case 'PUBLICWWW':
      return { tab: 'publicwww', sectionId: 'tab-publicwww' };
    case 'CERTIFICATE_SAN':
      return { tab: 'crtsh', sectionId: 'tab-crtsh' };
    case 'OTHER_INFORMATION':
      return { tab: 'manual', sectionId: null };
    default:
      return { tab: 'securitytrails', sectionId: null };
  }
}

export function scrollAndHighlightElement(selector, { block = 'start' } = {}) {
  if (typeof document === 'undefined' || !selector) return false;
  const el = document.querySelector(selector);
  if (!el) return false;
  el.scrollIntoView({ behavior: 'smooth', block });
  el.style.outline = '2px solid #3b82f6';
  el.style.borderRadius = '8px';
  window.setTimeout(() => {
    el.style.outline = '';
    el.style.borderRadius = '';
  }, 2500);
  return true;
}

/** Retry until the destination section is in the DOM (tabs/accordions paint after state updates). */
export function scheduleScrollAndHighlight(selector, { block = 'start', attempts = 10, delayMs = 200, initialDelayMs = 350 } = {}) {
  if (typeof window === 'undefined' || !selector) return () => {};
  let remaining = attempts;
  let timer = null;
  const run = () => {
    if (scrollAndHighlightElement(selector, { block })) return;
    remaining -= 1;
    if (remaining > 0) {
      timer = window.setTimeout(run, delayMs);
    }
  };
  timer = window.setTimeout(run, initialDelayMs);
  return () => {
    if (timer) window.clearTimeout(timer);
  };
}
